export const screenBreakpoints = {
  sm: 600,
  md: 900,
}
